/*
  异常边界class组件
*/
import React from "react";

type FallbackRender = (props: { error: Error | null }) => React.ReactElement;

export class ErrorBoundary extends React.Component<
  // { children: ReactNode; fallbackRender: FallbackRender }
  React.PropsWithChildren<{ fallbackRender: FallbackRender }>,
  any
> {
  state = { error: null };

  //当子组件抛出异常, 此处会接收并调用
  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { fallbackRender, children } = this.props;
    if (error) {
      return fallbackRender({ error });
    }
    return children;
  }
}
